export const formatUtcDateTime = (ms: number | undefined): string => {
    if (!ms) return "—";
    return new Date(ms).toISOString();
};

export const fmtVal = (rule: unknown): string => {
    if (!rule) return "—";
    const r = rule as Record<string, unknown>;
    if (r.type === "range") return `${r.min} to ${r.max}`;
    return (r.value as string) ?? "—";
};

// Keep floating menu coordinates constrained to the viewport bounds.
export const clampMenuPosition = (
    top: number,
    left: number,
    menuWidth: number,
    menuHeight: number,
    viewportWidth: number,
    viewportHeight: number,
    margin: number,
): { top: number; left: number } => {
    const maxLeft = viewportWidth - menuWidth - margin;
    const maxTop = viewportHeight - menuHeight - margin;
    return {
        left: Math.min(Math.max(left, margin), Math.max(margin, maxLeft)),
        top: Math.min(Math.max(top, margin), Math.max(margin, maxTop)),
    };
};

// Parse persisted scrollTop safely from session storage values.
export const parseStoredScrollTop = (value: string | null): number | null => {
    if (value === null) return null;
    const parsed = Number(value);
    return Number.isNaN(parsed) ? null : parsed;
};

export const FILTER_OPERATOR = {
  enabledSearch: false,
  multiselection: false,
  placeholder: 'Operator',
  options: [
    { label: '= Equals', value: '= Equals' },
    { label: '≠ not Equals', value: '≠ not Equals' },
  ],
};

export const normalizeFilterValue = (value?: string | null) => {
  const trimmed = value?.trim();
  return trimmed && trimmed.length > 0 ? trimmed : '—';
};

export const buildFilterOptions = (values: Array<string | undefined | null>) => {
  const unique = Array.from(new Set(values.map(normalizeFilterValue)));
  return unique.sort().map((value) => ({ label: value, value }));
};

export const buildFilterItem = (label: string, options: { label: string; value: string }[]) => ({
  label,
  value: label,
  operator: FILTER_OPERATOR,
  properties: { enabledSearch: true, multiselection: true, placeholder: 'Value', options },
});